import React, { memo } from 'react'
import HeaderNav from './HeaderNav'

import ProfileSection from './ProfileSection'
import LogoAnimated from '../Logo/LogoAnimated'
import Link from 'components/CommonUI/Link/Link'
import AlertItem from './AlertItem'
import {useSelector} from 'react-redux'
import {getIsAuthSelector} from 'redux/reducers/profile'
import Button from '../CommonUI/Button/Button'
import { routingConstants } from 'constants/routingConstants'
import Person from '../CommonUI/svgIcons/Person'
import {makeStyles} from '@material-ui/core/styles'

const useStylesButton = makeStyles(() => {
    return {
        root: {
            height: '45px',
        },
    }
})

const Header = () => {

  const isAuth = useSelector(getIsAuthSelector)
    const classesButton = useStylesButton()

  return (
    <div className="header">
      {isAuth && (<div className="header-wrapper">
        <div className="header_item logo_container">
          <Link to="/">
            <LogoAnimated/>
          </Link>
        </div>
        <HeaderNav/>
        <div className="profile_alert_container header_item">
          <AlertItem/>
          <ProfileSection/>
        </div>
      </div>)}
      {!isAuth && (
          <div className="header-wrapper">
            <div className="header_item logo_container">
              <Link to="/">
                <LogoAnimated/>
              </Link>
            </div>

              <div className="save_button_container form_row">
                  <Button className={classesButton.root} type="submit">
                      <Link className="header_button_link" to={routingConstants.auth}>
                          <Person className="icon_person_header" color={'#ffffff'}/>
                          Login
                      </Link>
                  </Button>
              </div>
          </div>
      )}
      <hr className="separated-line-content"></hr>
    </div>
  )
}

export default memo(Header)
